exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:johnston;src:url(" + require("./fonts/johnston_itc_light.ttf") + ")}@font-face{font-family:johnstonBold;src:url(" + require("./fonts/johnston_itc_bold_sc.ttf") + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":false}!./ClientApp/style.css
// module id = 106
// module chunks = 0